require('./search.less');
require('../../app/app');
var i18n = require('i18n');
var ajax = require('@enhancer/fe-util-ajax');
var util = require('../../app/util');
var pageConfig = window.pageConfig;
var pagination = require('../../app/pagination');


var wrapper = require('./main.html');
window.pageConfig.topicType = Object.keys(window.pageConfig.topicType || {});
if (window.pageConfig.topicType.length) {
	window.pageConfig.topicType.unshift('all');
}
window.pageConfig.topicType = window.pageConfig.topicType.map(function (key) {
	return {
		value: key,
		text: i18n(key)
	}
});
window.pageConfig.fields = ['title', 'content', 'tags', 'comments'].map(function(key) {
	return {
		value: key,
		text: i18n('search.' + key)
	}
});
$('body').append(wrapper(window.pageConfig));

$('#type-question').prop('checked', true);

var topicList = require('../../app/topicList.html');

$('.enhancer-search-btn').click( function () {
	doSearch();
});

function doSearch() {
	var key = $('.enhancer-search').val().trim();
	$('.enhancer-search').data('search', key);
	if (!key) {
		$('.ui.enhancer-loading').removeClass('loader');
		return;
	}
	var type = $('.enhancer-search-type option:selected').val();
	if (type == 1) {
		var site = location.host.split('.');
		site = site[site.length - 2] + '.' + site[site.length - 1];
		window.open('https://www.google.com/search?q=' + encodeURIComponent(key) + '+site:' + site);
		return
	}

	var advance = !$('.advance-search .icon').hasClass('down');
	var url = `${pageConfig.projectName}/search/page?key=${key}`;

	if (advance) {
		var field = []; 
		$('.search-option .search-field input:checked').each(function () {
			field.push($(this).val());
		});

		if (!field.length) {
			$('.ui.enhancer-loading').removeClass('loader');
			return
		}
		if (field.length !== $('.search-option .search-field input').length) {
			url += '&field=' + field.join(',');
		}
		

		var searchPlate = $('.search-plate input[type=hidden][name=plate]').val();
		if (searchPlate) {
			url += '&plate=' + searchPlate;
		}
		if (searchPlate  === 'qa') {
			var topicType = $('.search-option .search-type input:checked').val();
			if (topicType !== 'all' && topicType) {
				url += '&type=' + topicType;
			}
		}
	} 

	$('.pagination').off('click');
	pagination(url, topicList, function(page, data, first) {
		if (first && data.tuts) {
			tutPage = 0;
			renderTut(data.tuts);
			$('.tut-list-wrap .left').toggleClass('disabled', true);
			$('.tut-list-wrap .right').toggleClass('disabled', data.tuts.length < 3);
			$('.tut-list-wrap').toggleClass('hide', !data.tuts.length);
		}
	}, function (item) {
	}, {
		refresh: !firstClick,
		search: true
	});
	firstClick = false;

	util.setHash({
		key: key
	});
}

var tutPage = 0;
function renderTut (data) {
	const map = {
		tutorials: 'tutorials/1.1.0/zh-cn/',
		'tutorials-api': 'tutorials-api/1.0.0/zh-cn/',
		'tutorials-video': 'tutorials-video/1.0.0/zh-cn/',
		'tutorials-portal': 'tutorials-portal/0.1.0/zh-cn/',
		'tutorials-widget': 'tutorials-widgets/1.0.0/zh-cn/components/'
	}
	$('.tut-list').html(data.map(function(item) {
		return `<div class="tut-item">
			<a class="tut-title" target="_blank" href="https://assets.wuyuan.io/enhancer/${map[item.cate]}${item.url}">${item.title}</a>
			<div class="tut-highlight">${item.highlight}</div>
		</div>`
	}).join(''));
}

$('.tut-list-wrap').on('click', '.right:not(.disabled)', function(e) {
	tutPage++;
	loadTut(function () {
		$('.tut-list-wrap .left').toggleClass('disabled', false);
	});
});
$('.tut-list-wrap').on('click', '.left:not(.disabled)', function(e) {
	tutPage--;
	loadTut(function () {
		$('.tut-list-wrap .right').toggleClass('disabled', false);
		$('.tut-list-wrap .left').toggleClass('disabled', tutPage === 0);
	});
});
function loadTut (cb) {
	var key = $('.enhancer-search').data('search');
	ajax({
		url: `${pageConfig.projectName}/tut/page?key=${key}&page=${tutPage}`
	},function (res) {
		if (!res.data.length) {
			tutPage--;
			$('.tut-list-wrap .right').toggleClass('disabled', true);
			return
		} else {
			$('.tut-list-wrap .right').toggleClass('disabled', res.data.length < 3);
			renderTut(res.data);
			cb()
		}
	});
}

$('input.enhancer-search').on('keyup', function (e) {
	if (e.keyCode === 13) {
		doSearch();
	}
})

var key = location.hash.match(/key=([^&]+)/);
var firstClick = false;
if (key) {
	key = key[1];
	firstClick = true;
	try {
		key = decodeURIComponent(key);
	} catch (e) {
	}
	$('.enhancer-search').val(key);
	var type = location.hash.match(/type=([^&]+)/);
	$('.ui.dropdown').dropdown('set selected', type ? type[1] : 0);
	$('.enhancer-search-btn').click();
} else {
	$('.ui.enhancer-loading').removeClass('loader');
}


$('.new-topic').click( function (e) {
	e.preventDefault();
	try {
		localStorage.setItem('enhancerNewTopic', '1');
	} catch (e) {}
	
	location.href = pageConfig.projectName + '/';
});


$('.advance-search').click(function () {
	var icon = $(this).find('.icon');
	icon.toggleClass('down');
	$('.search-option').css({
		display: icon.hasClass('down') ? 'none' : 'block'
	});
});

$('.search-plate .dropdown.ui').dropdown({
	onChange: function(value, text) {
		$('.search-option .search-type').css('visibility', value === 'qa' ? 'visible' : 'hidden');
	}
});






// WEBPACK FOOTER //
// ./src/pages/search/search.js